<div class="d-flex h-100">
    @if (translateService.translation$ | async) {
        <router-outlet />
    } @else {
        <app-load />
    }
</div>
